import type { LabelHTMLAttributes, ReactNode } from "react";
import { cn } from "../lib/cn.ts";

export type FieldProps = LabelHTMLAttributes<HTMLLabelElement> & {
  label: string;
  children: ReactNode;
};

export function Field({ label, children, className, ...props }: FieldProps) {
  return (
    <label className={cn("flex flex-col gap-1.5", className)} {...props}>
      <span className="text-[11.5px] font-semibold uppercase tracking-wide text-[var(--sf-text-secondary)]">
        {label}
      </span>
      {children}
    </label>
  );
}
